import './style.scss';

export function all_faqs_block() {
    const block = document.querySelector('.all_faqs_block');
    if (!block) return;

    // ---------------------------
    // Accordion
    // ---------------------------
    function addAccordionListener(accordion) {
        if (!accordion) return;

        accordion.addEventListener("click", (e) => {
            const activePanel = e.target.closest(".accordion-panel");
            if (!activePanel) return;
            toggleAccordion(activePanel, accordion);
        });
    }

    function toggleAccordion(panelToActivate, accordionScope) {
        accordionScope.querySelectorAll(".accordion-panel").forEach((panel) => {
            const button = panel.querySelector("button");
            const content = panel.querySelector(".accordion-content");

            if (panel !== panelToActivate) {
                button?.setAttribute("aria-expanded", "false");
                content?.setAttribute("aria-hidden", "true");
            }
        });

        const activeButton = panelToActivate.querySelector("button");
        const activePanel = panelToActivate.querySelector(".accordion-content");
        const isOpened = activeButton?.getAttribute("aria-expanded");

        if (!activeButton || !activePanel) return;

        if (isOpened === "true") {
            activeButton.setAttribute("aria-expanded", "false");
            activePanel.setAttribute("aria-hidden", "true");
        } else {
            activeButton.setAttribute("aria-expanded", "true");
            activePanel.setAttribute("aria-hidden", "false");
        }
    }

    block.querySelectorAll(".accordion").forEach(addAccordionListener);

    // ---------------------------
    // Tabs (click + scrollspy)
    // ---------------------------
    // ---------------------------
    // Tabs (click + scrollspy)
    // ---------------------------
    const navItems = Array.from(block.querySelectorAll('.faq-nav-item'));
    const sections = Array.from(block.querySelectorAll('.faq-archive-section[id]'));

    const headerOffset = 0;
    const ALL_ID = 'all';

    let isClickScrolling = false;
    let scrollTimeout = null;

    function setActiveTabById(id) {
        navItems.forEach((item) => {
            const href = item.getAttribute('href');
            const itemTarget = href && href.startsWith('#') ? href.substring(1) : null;

            const isAll = !href || href === '#top';
            const shouldBeActive = (id === ALL_ID && isAll) || (itemTarget === id);

            item.classList.toggle('active', shouldBeActive);
        });
    }

    setActiveTabById(ALL_ID);

    function startManualScroll() {
        isClickScrolling = true;
        if (scrollTimeout) clearTimeout(scrollTimeout);
        // Reset flag after 1 second (enough for smooth scroll to finish mostly)
        scrollTimeout = setTimeout(() => {
            isClickScrolling = false;
        }, 1000);
    }

    navItems.forEach((item) => {
        item.addEventListener('click', (e) => {
            const href = item.getAttribute('href');

            if (!href) {
                e.preventDefault();
                startManualScroll();
                setActiveTabById(ALL_ID);

                const blockTop = block.getBoundingClientRect().top + window.pageYOffset - headerOffset;
                window.scrollTo({ top: blockTop, behavior: 'smooth' });
                return;
            }

            if (href.startsWith('#')) {
                e.preventDefault();

                const targetId = href.substring(1);

                // Special case for #top -> All FAQs
                if (targetId === 'top') {
                    startManualScroll();
                    setActiveTabById(ALL_ID);

                    const blockTop = block.getBoundingClientRect().top + window.pageYOffset - headerOffset;
                    window.scrollTo({ top: blockTop, behavior: 'smooth' });
                    return;
                }

                const targetEl = document.getElementById(targetId);
                if (!targetEl) return;

                startManualScroll();
                setActiveTabById(targetId);

                const offsetPosition =
                    targetEl.getBoundingClientRect().top + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            }
        });
    });

    // ✅ ScrollSpy: highlight tab when its section is visible
    const observer = new IntersectionObserver(
        (entries) => {
            if (isClickScrolling) return; // Ignore observer during manual scroll

            const visible = entries
                .filter((en) => en.isIntersecting)
                .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

            if (visible?.target?.id) {
                setActiveTabById(visible.target.id);
            }
        },
        {
            root: null,
            rootMargin: `-${headerOffset}px 0px -60% 0px`,
            threshold: [0.1, 0.2, 0.3, 0.4]
        }
    );

    sections.forEach((sec) => observer.observe(sec));

    // ✅ If user scrolls above first section → force All FAQs active
    if (sections.length) {
        const firstSection = sections[0];

        window.addEventListener('scroll', () => {
            if (isClickScrolling) return;

            const firstTop =
                firstSection.getBoundingClientRect().top + window.pageYOffset - headerOffset;

            // لو المستخدم فوق أول سيكشن بفرق بسيط → All FAQs active
            if (window.pageYOffset < firstTop - 10) {
                setActiveTabById(ALL_ID);
            }
        }, { passive: true });
    } else {
        // لو مفيش سيكشنات لأي سبب
        setActiveTabById(ALL_ID);
    }
}
